import { View, StyleSheet } from 'react-native';

import DataState from 'app/src/components/DataState';
import { elGray } from 'app/src/styles/colors';

import APAgingDetail from './APAgingDetail';
import ARAgingDetail from './ARAgingDetail';
import BalanceSheet from './BalanceSheet';
import CashFlow from './CashFlow';
import GeneralLedger from './GeneralLedger';
import ProfitAndLoss from './ProfitAndLoss';
import TrialBalance from './TrialBalance';
import TxnJournal from './TxnJournal';
import AssetGain from './AssetGain';
import WIPReconcile from './WIPReconcile';

import { styles } from './styles';

export const REPORT_PERIODS = [
  { label: 'Year to Date', value: 'YTD' },
  { label: 'Month to Date', value: 'MTD' },
  { label: 'YTD MTD Comparison', value: 'YTD MTD Comparison' },
  { label: 'Trailing Twelve Month', value: 'TTM' },
  { label: 'Year-over-Year', value: 'YOY' },
  { label: 'YOY for Month', value: 'YOY for Month' },
  { label: 'YOY for Quarter', value: 'YOY for Quarter' },
  { label: 'All Time', value: 'All' },
];

export const END_ONLY_REPORT_PERIODS = [
  { label: 'No Comparison', value: 'MTD' },
  { label: 'Trailing Twelve Month', value: 'TTM' },
  { label: 'Year-over-Year', value: 'YOY' },
];

const Reports = () => {
  return (
    <View style={styles.container}>
      <ProfitAndLoss />
      <BalanceSheet />
      <CashFlow />
      <TrialBalance />
      <GeneralLedger />
      <TxnJournal />
      <APAgingDetail />
      <ARAgingDetail />
      <AssetGain />
      <WIPReconcile />
    </View>
  );
};

export default Reports;
